import {useEffect, useRef, useState} from "react";
import {TextLinkButton} from "./Button";
import {useTranslation} from "react-i18next";

export const NodesMap = ({}) => {
    const nodeMap = useRef();
    const [data, setData] = useState({});
    const {t} = useTranslation();
   const fetchNodes = async () => {
        const response = await fetch('https://theta-mkt-api.thetatoken.org/v1/nodes/locations/optimized');
        const data = await response.json();
        return data;
   }

    useEffect( () => {
        fetchNodes().then((data) => {
            setData(data);
            nodeMap.current.contentWindow.postMessage(
                {
                    type: "populateMapOptimized",
                    data: data
                }, '*');
        });
    }, []);

    const formatNumber = (num) => {
        if (!num) return '-';
        return Number(num).toLocaleString();
    };

    return (
        <div className={'NodesMap'}>
            <div className={'NodesMap__desktop'}>
                <iframe id='nodes-map'
                        ref={nodeMap}
                        title={'nodes map'}
                        src={'/map.html'}
                />
                <div className={'NodesMapLegend'}>
                    <div className={'NodesMapLegendItem NodesMapLegendItem--en'}>
                        <span className={'NodesMapLegendItem__title'}>
                            {t('common.active-edge-node')}
                        </span>
                        <span className={'NodesMapLegendItem__count'}>
                            {data?.totals?.en || '-'}
                        </span>
                    </div>
                    <div className={'NodesMapLegendItem NodesMapLegendItem--gn'}>
                        <span className={'NodesMapLegendItem__title'}>
                            {t('common.guardian-node')}
                        </span>
                        <span className={'NodesMapLegendItem__count'}>
                            {data?.totals?.gn || '-'}
                        </span>
                    </div>
                    <div className={'NodesMapLegendItem NodesMapLegendItem--vn'}>
                        <span className={'NodesMapLegendItem__title'}>
                            {t('common.validator-node')}
                        </span>
                        <span className={'NodesMapLegendItem__count'}>
                            {data?.totals?.validator || '-'}
                        </span>
                    </div>
                </div>
            </div>

            <div className={'NodesMap__mobile'}>
                <div className={'NodesMap__mobile-stat NodesMap__mobile-stat--en'}>
                    <span className={'NodesMap__mobile-number'}>
                        {formatNumber(data?.totals?.en)}
                    </span>
                    <span className={'NodesMap__mobile-label'}>
                        {t('common.active-edge-node')}
                    </span>
                </div>
                <div className={'NodesMap__mobile-stat NodesMap__mobile-stat--gn'}>
                    <span className={'NodesMap__mobile-number'}>
                        {formatNumber(data?.totals?.gn)}
                    </span>
                    <span className={'NodesMap__mobile-label'}>
                        {t('common.guardian-node')}
                    </span>
                </div>
                <div className={'NodesMap__mobile-stat NodesMap__mobile-stat--vn'}>
                    <span className={'NodesMap__mobile-number'}>
                        {formatNumber(data?.totals?.validator)}
                    </span>
                    <span className={'NodesMap__mobile-label'}>
                        {t('common.validator-node')}
                    </span>
                </div>
            </div>
        </div>
    );
}